/**
 * Étiquettes d'article traduites (B6). Les étiquettes du blog sont des mots
 * anglais saisis à la main (« tips », « Vegetable & Plant ») : on n'affiche que
 * celles du dictionnaire `articles.tags.*`, jamais une étiquette brute.
 */
export const KNOWN_ARTICLE_TAGS = [
  'tips',
  'carrot',
  'terrace',
  'vegetable-plant',
  'spring',
  'summer',
  'autumn',
  'winter',
] as const;

/** « Vegetable & Plant » → « vegetable-plant ». */
export function articleTagKey(tag: string): string {
  return tag
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

/** Clés de traduction des étiquettes connues, sans doublon, dans l'ordre du blog. */
export function articleTagKeys(tags: string[] | null | undefined): string[] {
  const known = new Set<string>(KNOWN_ARTICLE_TAGS);
  const keys = (tags ?? []).map(articleTagKey).filter((key) => known.has(key));
  return [...new Set(keys)].map((key) => `articles.tags.${key}`);
}

/** Titre sans l'emoji de tête (« 🌱 La rotation des cultures »), ajouté pour le blog. */
export function articleDisplayTitle(title: string | null | undefined): string {
  return (title ?? '').replace(/^[\p{Extended_Pictographic}\p{Emoji_Modifier}‍️\s]+/u, '').trim();
}
